/**
 * @generated SignedSource<<25b39a0ff710b0c4785dcbfb43a15994>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_ConfiguratorModelQuery$variables = {
  id: string;
};
export type productSidePanelContent_ConfiguratorModelQuery$data = {
  readonly node: {
    readonly attributes?: ReadonlyArray<{
      readonly attributeCode: string | null;
      readonly description: string | null;
      readonly name: string | null;
      readonly options: ReadonlyArray<{
        readonly actions: ReadonlyArray<{
          readonly actionID: number;
          readonly actionTypeID: number;
          readonly name: string | null;
          readonly propertyName: string | null;
          readonly sceneElementTypeID: number;
          readonly selector: string | null;
          readonly value: string | null;
        } | null> | null;
        readonly constraintExpression: {
          readonly op: string | null;
        } | null;
        readonly description: string | null;
        readonly imageUrl: string | null;
        readonly name: string | null;
        readonly optionCode: string | null;
        readonly optionID: number | null;
      } | null> | null;
      readonly postActions: ReadonlyArray<{
        readonly actionID: number;
        readonly actionTypeID: number;
        readonly name: string | null;
        readonly propertyName: string | null;
        readonly sceneElementTypeID: number;
        readonly selector: string | null;
        readonly value: string | null;
      } | null> | null;
      readonly preActions: ReadonlyArray<{
        readonly actionID: number;
        readonly actionTypeID: number;
        readonly name: string | null;
        readonly propertyName: string | null;
        readonly sceneElementTypeID: number;
        readonly selector: string | null;
        readonly value: string | null;
      } | null> | null;
      readonly pricings: ReadonlyArray<{
        readonly attributePricingID: number;
        readonly price: number;
        readonly selectedOptionID: number | null;
      } | null> | null;
      readonly valueActions: ReadonlyArray<{
        readonly actionID: number;
        readonly actionTypeID: number;
        readonly name: string | null;
        readonly propertyName: string | null;
        readonly sceneElementTypeID: number;
        readonly selector: string | null;
        readonly value: string | null;
      } | null> | null;
    }>;
    readonly scenes?: ReadonlyArray<{
      readonly meshDesignEffects: ReadonlyArray<{
        readonly effectID: any;
        readonly materialID: any | null;
        readonly meshID: any;
        readonly name: string | null;
        readonly subMeshID: number;
      }>;
      readonly meshSides: ReadonlyArray<{
        readonly meshID: any;
        readonly sideID: number;
      }>;
      readonly sceneID: any;
    }>;
  } | null;
};
export type productSidePanelContent_ConfiguratorModelQuery = {
  response: productSidePanelContent_ConfiguratorModelQuery$data;
  variables: productSidePanelContent_ConfiguratorModelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meshID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelScene",
  "kind": "LinkedField",
  "name": "scenes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sceneID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelSceneMeshSide",
      "kind": "LinkedField",
      "name": "meshSides",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sideID",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelSceneMeshDesignEffect",
      "kind": "LinkedField",
      "name": "meshDesignEffects",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "effectID",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subMeshID",
          "storageKey": null
        },
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "materialID",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attributeCode",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actionID",
    "storageKey": null
  },
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sceneElementTypeID",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actionTypeID",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "selector",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "propertyName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionID",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionCode",
      "storageKey": null
    },
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeSceneAction",
      "kind": "LinkedField",
      "name": "actions",
      "plural": true,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeExpression",
      "kind": "LinkedField",
      "name": "constraintExpression",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "op",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributePricing",
  "kind": "LinkedField",
  "name": "pricings",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attributePricingID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selectedOptionID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeSceneAction",
  "kind": "LinkedField",
  "name": "preActions",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeSceneAction",
  "kind": "LinkedField",
  "name": "valueActions",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeSceneAction",
  "kind": "LinkedField",
  "name": "postActions",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_ConfiguratorModelQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Attribute",
                "kind": "LinkedField",
                "name": "attributes",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Model",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_ConfiguratorModelQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Attribute",
                "kind": "LinkedField",
                "name": "attributes",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Model",
            "abstractKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1804dcb0de3c683ac8285e0c77756ae8",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_ConfiguratorModelQuery",
    "operationKind": "query",
    "text": "query productSidePanelContent_ConfiguratorModelQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Model {\n      scenes {\n        sceneID\n        meshSides {\n          meshID\n          sideID\n        }\n        meshDesignEffects {\n          effectID\n          meshID\n          subMeshID\n          name\n          materialID\n        }\n      }\n      attributes {\n        name\n        attributeCode\n        description\n        options {\n          optionID\n          name\n          optionCode\n          description\n          imageUrl\n          actions {\n            actionID\n            name\n            sceneElementTypeID\n            actionTypeID\n            selector\n            propertyName\n            value\n          }\n          constraintExpression {\n            op\n          }\n        }\n        pricings {\n          attributePricingID\n          selectedOptionID\n          price\n        }\n        preActions {\n          actionID\n          name\n          sceneElementTypeID\n          actionTypeID\n          selector\n          propertyName\n          value\n        }\n        valueActions {\n          actionID\n          name\n          sceneElementTypeID\n          actionTypeID\n          selector\n          propertyName\n          value\n        }\n        postActions {\n          actionID\n          name\n          sceneElementTypeID\n          actionTypeID\n          selector\n          propertyName\n          value\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f1a4084fd7e25db8e0ade00963bafca";

export default node;
